import React from 'react';
import BlackAndWhiteButton from 'src/components/BlackGrayButton/BlackGrayButton';
import LabelInput, { IInputType } from 'src/components/TopLabelInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';

const BtnInput = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    btns = [],
    btnValue,
    inputValue,
    inputValueError,
    inputOnChange,
  } = props;
  const BtnsGroup = btns.map((btn, index) => {
    const { onClick, value, text } = btn;
    return (
      <BlackAndWhiteButton
        key={index}
        size='small'
        onClick={onClick}
        checked={btnValue === value}
        className={index === 0 ? css.firstBtn : css.rightBtn}>
        {text}
      </BlackAndWhiteButton>
    );
  });
  return (
    <React.Fragment>
      {BtnsGroup}
      <div className={css.valueInput}>
        <LabelInput
          //   min={0}
          fromRight
          type={IInputType.Number}
          value={inputValue}
          error={inputValueError}
          onChange={inputOnChange}
          label={getI18n('general.value')}
          size='small'
          className={css.firstInput}
        />
      </div>
    </React.Fragment>
  );
};
export default BtnInput;
